export default "__VITE_ASSET__dk5Gilv$__"